<div class="col-sm-12 col-md-7 col-lg-8"
    [ngClass]="showMessagePanelForSmallScreen !== undefined ? (showMessagePanelForSmallScreen === true ? 'd-block' : 'd-none') : ''">
    <div id="message-panel-card" class="card card-border message-panel-height">
        <ng-container *ngIf="loadGroupChatPayload !== null">

            <div class="row px-4">
                <div class="col-xs-12 col-sm-12 my-3">
                    <div class="d-flex column-gap width-100 justify-content-between">
                        <div class="d-flex width-90">
                            <div class="d-flex flex-column justify-content-center mr-4 display-large-none ">
                                <button class="plus-icon" title="Go Back" (click)="goToChatListPage()">
                                    <i class="fa fa-chevron-circle-left fa-lg"></i>
                                </button>
                            </div>
                            <div class="d-flex flex-column">
                                <div class="d-flex align-items-center justify-content-between">
                                    <div class="d-flex align-items-center flex-wrap max-width">
                                        <div *ngIf="(isInternal || isLoggedInMemberAGroupAdmin) && loadGroupChatPayload.groupDetail.isEnabled === true"
                                            (click)="openGroupInfoDialog(groupMemberList, loadGroupChatPayload.groupDetail)">
                                            <h4 class="cursorPointer overflow-ellipsis max-width">
                                                {{loadGroupChatPayload.groupDetail.groupName}}
                                            </h4>
                                        </div>
                                        <div
                                            *ngIf="(!isInternal && !isLoggedInMemberAGroupAdmin) || loadGroupChatPayload.groupDetail.isEnabled === false">
                                            <h4 class="overflow-ellipsis max-width">
                                                {{loadGroupChatPayload.groupDetail.groupName}}
                                            </h4>
                                        </div>
                                        <div class="ml-2">
                                            <span class="badge cursorPointer"
                                                (click)="gotoItineraryPage(loadGroupChatPayload.serviceRequestDetail.serviceRequestId)">
                                                <span>{{loadGroupChatPayload.serviceRequestDetail.tripId}}</span>
                                            </span>
                                        </div>
                                        <div *ngIf="loadGroupChatPayload.groupDetail.isEnabled === true"
                                            class="ml-2 cursorPointer refresh-button">
                                            <i *ngIf="!isRefreshing" class="fa"
                                                (click)="isRefreshing = true; refreshMessagePanel()">&#xf021;</i>
                                            <i *ngIf="isRefreshing" class="fa fa-refresh fa-spin"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex dark-grey mr-5">
                                    <span class="d-block overflow-ellipsis max-width">
                                        <span *ngIf="groupMemberListOnHeaderLoader">
                                            Group Info
                                        </span>
                                        <span class="cursorPointer"
                                            *ngIf="!groupMemberListOnHeaderLoader && (isInternal || isLoggedInMemberAGroupAdmin) && loadGroupChatPayload.groupDetail.isEnabled === true"
                                            (click)="openGroupInfoDialog(groupMemberList, loadGroupChatPayload.groupDetail)">
                                            {{ memberListToShowOnHeader.toString().split(',').join(', ') }}
                                        </span>
                                        <span
                                            *ngIf="!groupMemberListOnHeaderLoader && ((!isInternal && !isLoggedInMemberAGroupAdmin) || loadGroupChatPayload.groupDetail.isEnabled === false)">
                                            {{ memberListToShowOnHeader.toString().split(',').join(', ') }}
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="loadGroupChatPayload.groupDetail.isEnabled === true" id="more-option-container"
                            class="d-flex flex-column text-danger cursorPointer justify-content-center width-10"
                            (click)="isMoreOptionVisible = !isMoreOptionVisible">
                            <i class="fa fa-ellipsis-v fa-lg"></i>
                        </div>
                        <div class="card card-layout card-border more-info-container font-medium dark-grey px-0 py-3 cursorPointer"
                            *ngIf="isMoreOptionVisible">

                            <div *ngIf="isInternal || isLoggedInMemberAGroupAdmin" class="more-info-option" id="more1"
                                (click)="openGroupInfoDialog(groupMemberList, loadGroupChatPayload.groupDetail)">
                                Group Info
                            </div>
                            <div class="more-info-option" id="more2" (click)="exitGroup()">
                                Exit Group
                            </div>
                            <div *ngIf="isDeleteGroupOptionVisible" class="more-info-option" id="more3"
                                (click)="deleteGroup()">
                                Delete Group
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <mat-divider></mat-divider>

            <div id="message-section" class="row px-4 message-section">
                <div class="col-xs-12 col-sm-12 p-4 height-100 scrollbarView" id="message-panel">
                    <ng-container *ngIf="messageList.length > 0">
                        <ng-container *ngFor="let message of messageList; let i = index; trackBy: messageTrackBy">
                            <!-- INCOMING MESSAGE CONTAINER -->
                            <ng-container *ngIf="message.memberId !== user.memberId">
                                <div class="d-flex mt-2" [id]="message.messageId">
                                    <div
                                        [ngClass]="i > 0 && messageList[i].memberId === messageList[i-1].memberId ? 'visibility-hidden' : ''">
                                        <div *ngIf="checkIsProfilePicAvailable(message.memberId)"
                                            (click)="openMemberInfoDialog(message)"
                                            [ngClass]="isInternal ? 'cursorPointer' : ''">
                                            <img [src]="checkIsProfilePicAvailable(message.memberId)"
                                                class="profile-pic" [alt]="message.memberInitials">
                                        </div>
                                        <div *ngIf="!checkIsProfilePicAvailable(message.memberId)"
                                            (click)="openMemberInfoDialog(message)"
                                            [style.background]="memberProfileColor(message.memberId) ? memberProfileColor(message.memberId) : '#8A8A8A'"
                                            class="initials-container" [ngClass]="isInternal ? 'cursorPointer' : ''">
                                            <span class="initials">{{ message.memberInitials }}</span>
                                        </div>
                                    </div>
                                    <div class="message-container text-message incoming-message-container-bg-color ml-5"
                                        [ngClass]="{
                                            'media-file': message.fileName !== null && messageAttachmentLoader,
                                            'tri-right left-top mt-4': (i > 0 && messageList[i].memberId !== messageList[i-1].memberId) || i === 0
                                        }">
                                        <div class="message-text-container px-3 pb-2">
                                            <h5 class="my-0 mb-2" (click)="openMemberInfoDialog(message)"
                                                [ngClass]="isInternal ? 'cursorPointer' : ''">
                                                {{ message.memberName }}
                                            </h5>
                                            <ng-container *ngIf="message.fileName">
                                                <div *ngIf="messageAttachmentLoader && !message.filePath"
                                                    class="background-white d-flex align-items-center justify-content-center height-10">
                                                    <mat-spinner [diameter]="25"></mat-spinner>
                                                </div>
                                                <div *ngIf="!messageAttachmentLoader && message.filePath"
                                                    class="d-flex justify-content-center align-content-center background-white cursorPointer"
                                                    (click)="openImagePreview(message.filePath)">
                                                    <img [src]="message.filePath" alt="Image" class="image-message">
                                                </div>
                                                <div *ngIf="!messageAttachmentLoader && message.filePath === null"
                                                    class="background-white d-flex align-items-center justify-content-center">
                                                    <mat-icon class="alert-icon">error_outline</mat-icon>
                                                </div>
                                            </ng-container>
                                            <app-read-more [text]="message.messageText" [maxLengthToShow]="800">
                                            </app-read-more>
                                            <div class="d-flex justify-content-end light-grey font-small">
                                                <span>
                                                    {{message.messageSendTime | localDate: timeZone}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <!-- OUTGOING MESSAGE CONTAINER -->
                            <ng-container *ngIf="message.memberId === user.memberId">
                                <div class="d-flex justify-content-end mt-2" [id]="message.messageId">
                                    <div class="message-container text-message outgoing-message-container-bg-color mr-5"
                                        [ngClass]="{
                                            'media-file': message.fileName !== null && messageAttachmentLoader,
                                            'tri-right right-top mt-4': (i > 0 && messageList[i].memberId !== messageList[i-1].memberId) || i === 0
                                        }">
                                        <div class="message-text-container px-2 pb-2">
                                            <ng-container *ngIf="message.fileName">
                                                <div class="background-white d-flex align-items-center justify-content-center height-10"
                                                    *ngIf="messageAttachmentLoader && !message.filePath">
                                                    <mat-spinner [diameter]="25"></mat-spinner>
                                                </div>
                                                <div *ngIf="!messageAttachmentLoader && message.filePath"
                                                    class="d-flex justify-content-center align-content-center background-white cursorPointer"
                                                    (click)="openImagePreview(message.filePath)">
                                                    <img [src]="message.filePath" alt="Image" class="image-message">
                                                </div>
                                                <div class="background-white d-flex align-items-center justify-content-center"
                                                    *ngIf="!messageAttachmentLoader && message.filePath === null">
                                                    <mat-icon class="alert-icon">error_outline</mat-icon>
                                                </div>
                                            </ng-container>
                                            <app-read-more [text]="message.messageText" [maxLengthToShow]="800">
                                            </app-read-more>
                                            <div class="d-flex justify-content-end light-grey font-small">
                                                <span *ngIf="message.messageSendTime === null && message.isSending">
                                                    <mat-spinner [diameter]="15"></mat-spinner>
                                                </span>
                                                <span
                                                    *ngIf="message.messageSendTime !== null && !message.isSending && message.isSentSuccessful === true">
                                                    {{ message.messageSendTime | localDate: timeZone }}
                                                </span>
                                                <span *ngIf="!message.isSending && message.isSentSuccessful === false">
                                                    <mat-icon class="alert-icon">error_outline</mat-icon>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <!-- INPUT FIELD CONTAINER -->
            <div class="row px-4">
                <div class="col-xs-12 col-sm-12 my-4 background-white">
                    <div class="d-flex align-items-end justify-content-center col-gap">
                        <ng-container
                            *ngIf="loadGroupChatPayload.groupDetail.isEnabled === true else noInputAllowedBlock">
                            <div class="input-bar flex-grow-1 text radius">
                                <ng-container *ngIf="imagePreview">
                                    <div class="image-preview-section d-flex justify-content-center">
                                        <span [ngClass]="isUploadFileLoading ? 'upload-image-loader-container' : ''">
                                            <span *ngIf="isUploadFileLoading"
                                                class="align-self-center img-align-center width-100-percent d-inline-block">
                                                <mat-spinner [diameter]="20"></mat-spinner>
                                            </span>
                                            <span *ngIf="!isUploadFileLoading"
                                                class="image-container-width img-align-center">
                                                <img [src]="imageURL" id="imagePreview"
                                                    class="image-preview cursorPointer"
                                                    (click)="openImagePreview(imageURL)" loading="eager" />
                                            </span>
                                        </span>
                                        <span class="cursorPointer">
                                            <mat-icon class="cancel-icon"
                                                (click)="closeImagePreview()">cancel</mat-icon>
                                        </span>
                                    </div>
                                </ng-container>
                                <div class="d-flex justify-content-center align-items-end col-gap text-input p-3">
                                    <mat-icon class="dark-grey radius-100 cursorPointer chat-icon pr-2"
                                        (click)="toggleEmojiPicker = !toggleEmojiPicker; updateCSSForEmojiPicker()"
                                        [(emojiPickerIf)]="toggleEmojiPicker"
                                        [emojiPickerDirection]="'top' || 'right' || 'bottom' || 'left'"
                                        (emojiPickerSelect)="selectEmoji($event)">sentiment_very_satisfied</mat-icon>
                                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                        cdkAutosizeMinRows="1" cdkAutosizeMaxRows="6" type="text"
                                        placeholder="Text message" id="message" name="message"
                                        [(ngModel)]="textMessageBody"
                                        (ngModelChange)="isSendButtonDisabled()"></textarea>
                                    <label for="file" class="cursorPointer upload-image-container mb-0">
                                        <mat-icon class="chat-icon">attach_file
                                            <input id="file" name="file" type="file" [(ngModel)]="fileAttachment"
                                                accept="image/png, image/gif, image/jpeg, image/jpg" class="d-none"
                                                (change)="uploadImage($event)" hidden />
                                        </mat-icon>
                                    </label>
                                </div>
                            </div>
                            <div class="action-buttons">
                                <button mat-mini-fab class="send-message-button" type="submit" title="Send Message"
                                    [disabled]="sendMessageBtnDisabled" (click)="uploadMessage()">
                                    <mat-icon>send</mat-icon>
                                </button>
                            </div>
                        </ng-container>
                        <ng-template #noInputAllowedBlock>
                            <span class="text-color">
                                Group is no longer active as Service Request is
                                <strong>{{loadGroupChatPayload.serviceRequestDetail.serviceRequestStatus}}</strong>
                            </span>
                        </ng-template>
                    </div>
                </div>
            </div>

        </ng-container>

        <ng-container *ngIf="loadGroupChatPayload === null">
            <!-- TODO: UI to show when there is no chat group loaded -->
        </ng-container>
    </div>
</div>
